import { func, node } from "prop-types";

import FnrButtonWrapper from "UI/FnrButtonWrapper";

const FnrButtonWrapperRelay = ({ onClick, children }) => {
  if (onClick)
    return <FnrButtonWrapper onClick={onClick}>{children}</FnrButtonWrapper>;
  return children;
};

FnrButtonWrapperRelay.propTypes = { onClick: func, children: node };

export default FnrButtonWrapperRelay;
